import * as actions from './actions';

const initialState = {
    isSaveInProgress: false,
    isDataLoaded: false
};

export default function (state = initialState, action) {
    switch (action.type) {
    case actions.GET_SETTING_PREFERENCE_SUCCESS: {
        return { ...state, settingPreferences: action.data, isDataLoaded: true };
    }
    case actions.SAVE_SETTING_PREFERENCE_REQUEST: {
        return { ...state, isSaveInProgress: true };
    }
    case actions.SAVE_SETTING_PREFERENCE_SUCCESS: {
        return { ...state, isSaveInProgress: false };
    }
    case actions.SAVE_SETTING_PREFERENCE_FAILURE: {
        return { ...state, isSaveInProgress: false };
    }

    default:
        return { ...state };
    }
}




// WEBPACK FOOTER //
// ./app/containers/privacy-settings/reducer.js